import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  getUserKycDetailsRoute,
  getSchoolKycDetailsRoute,
  getUserKycDocDetailsRoute,
  getSchoolKycDocDetailsRoute,
  getUserDetailsRoute,
} from '../../utils/apiRoutes';

export const getUserKycDetailsAsync = createAsyncThunk(
  `${moduleName}/getUserKycDetailsAsync`,
  async (payload) => {
    const { entityId } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getUserKycDetailsRoute(entityId),
    });
    const data = response.data;
    return data;
  }
);

export const getUserKycDocDetailsAsync = createAsyncThunk(
  `${moduleName}/getUserKycDocDetailsAsync`,
  async (payload) => {
    const { entityId } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getUserKycDocDetailsRoute(entityId),
    });
    const data = response.data;
    return data;
  }
);

export const getSchoolKycDetailsAsync = createAsyncThunk(
  `${moduleName}/getSchoolKycDetailsAsync`,
  async (payload) => {
    const { entityId } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getSchoolKycDetailsRoute(entityId),
    });
    const data = response.data;
    return data;
  }
);

export const getUserDetailsAsync = createAsyncThunk(
  `${moduleName}/getUserDetailsAsync`,
  async (payload) => {
    const { userId } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getUserDetailsRoute(userId),
    });
    const data = response.data;
    return data;
  }
);

export const getSchoolKycDocDetailsAsync = createAsyncThunk(
  `${moduleName}/getSchoolKycDocDetailsAsync`,
  async (payload) => {
    const { entityId } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getSchoolKycDocDetailsRoute(entityId),
    });
    const data = response.data;
    return data;
  }
);

const userKycApproveSlice = createSlice({
  name: `${moduleName}/UserKycApproval`,
  initialState: {
    loading: false,
    userKycDetails: null,
    userKycDocDetails: null,
    userKycApprovalId: null,
    userKycApprovalStatus: null,
    userKycApiStatus: 'pending',
    userDetails: null,
    schoolKycDetails: null,
    schoolKycDocDetails: null,
    schoolKycApprovalId: null,
    schoolKycApprovalStatus: null,
    schoolKycApiStatus: 'pending',
  },
  reducers: {
    // For user kyc
    emptyUserKycDetails: (state) => {
      state.userKycDetails = null;
    },
    storeUserKycApprovalId: (state, action) => {
      state.userKycApprovalId = action.payload;
    },
    storeUserKycApprovalStatus: (state, action) => {
      state.userKycApprovalStatus = action.payload;
    },
    storeUserKycApiStatus: (state, action) => {
      state.userKycApiStatus = action.payload;
    },
    // For school kyc
    emptySchoolKycDetails: (state) => {
      state.schoolKycDetails = null;
    },
    storeSchoolKycApprovalId: (state, action) => {
      state.schoolKycApprovalId = action.payload;
    },
    storeSchoolKycApprovalStatus: (state, action) => {
      state.schoolKycApprovalStatus = action.payload;
    },
    storeSchoolKycApiStatus: (state, action) => {
      state.schoolKycApiStatus = action.payload;
    },
  },
  extraReducers: {
    [getUserKycDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getUserKycDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.userKycDetails = action.payload.data;
    },
    [getUserKycDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getUserDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getUserDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.userDetails = action.payload;
    },
    [getUserDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getUserKycDocDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getUserKycDocDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.userKycDocDetails = action.payload.data;
    },
    [getUserKycDocDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolKycDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getSchoolKycDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.schoolKycDetails = action.payload.data;
    },
    [getSchoolKycDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolKycDocDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getSchoolKycDocDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.schoolKycDocDetails = action.payload.data;
    },
    [getSchoolKycDocDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const {
  emptyUserKycDetails,
  storeUserKycApprovalId,
  storeUserKycApprovalStatus,
  storeUserKycApiStatus,
  emptySchoolKycDetails,
  storeSchoolKycApprovalId,
  storeSchoolKycApprovalStatus,
  storeSchoolKycApiStatus,
} = userKycApproveSlice.actions;

export default userKycApproveSlice.reducer;
